import { FC } from 'react';

import { StyledIndicator, StyledRoot } from './Checkbox.styled';
import type { CheckboxProps } from './types';

const CheckIcon: FC = () => (
  <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 1L2.75 5.5L1 3.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IndeterminateIcon: FC = () => (
  <svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const Checkbox: FC<CheckboxProps> = ({
  size = 'md',
  indeterminate,
  id,
  'aria-labelledby': ariaLabelledBy,
  ...props
}) => (
  <StyledRoot
    $size={size}
    indeterminate={indeterminate}
    id={id}
    // The control renders as a non-native button, which `<label for>` cannot name, so it
    // would otherwise reach assistive technology as an unnamed checkbox. A labelled
    // checkbox points at the `<id>-label` element unless the caller names it directly.
    aria-labelledby={ariaLabelledBy ?? (id ? `${id}-label` : undefined)}
    {...props}
  >
    <StyledIndicator keepMounted>
      {indeterminate ? <IndeterminateIcon /> : <CheckIcon />}
    </StyledIndicator>
  </StyledRoot>
);

export default Checkbox;

Checkbox.displayName = 'Checkbox';
